// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page-specific styles for Schedule */

/* Flow */
.flow-header {
  height: 68px;
  padding: 0 1rem;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  border-bottom: 1px solid var(--line);
  background: var(--paper);
}
.flow-header .step-label {
  justify-self: end;
  color: var(--muted);
  font-size: 0.75rem;
  font-weight: 700;
}
.flow-container {
  max-width: 1060px;
  padding-top: 1.5rem;
  padding-bottom: 4rem;
}
.flow-progress {
  display: flex;
  gap: 0.4rem;
  margin-bottom: 2rem;
}
.flow-progress span {
  height: 4px;
  flex: 1;
  border-radius: 5px;
  background: var(--line);
}
.flow-progress span.active {
  background: var(--green-700);
}
.schedule-layout {
  display: grid;
  gap: 1.5rem;
}
.form-section {
  margin-bottom: 1rem;
  padding: 1.25rem;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.form-section-title {
  display: flex;
  gap: 0.8rem;
  margin-bottom: 1rem;
}
.form-section-title > span {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: white;
  background: var(--green-800);
  font-size: 0.75rem;
  font-weight: 800;
}
.form-section-title h2 {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0;
}
.form-section-title p {
  margin: 0.1rem 0 0;
  color: var(--muted);
  font-size: 0.78rem;
}

.scheduled-days-note p {
  color: rgb(24, 153, 125) !important;
}

.choice-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.6rem;
}
.choice-grid button {
  min-height: 94px;
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.45rem;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: white;
  position: relative;
  font-size: 0.78rem;
  font-weight: 700;
}
.choice-grid button > i:first-child {
  color: var(--green-700);
  font-size: 1.1rem;
}
.choice-grid button.selected,
.slot-list button.selected,
.day-grid button.selected {
  border-color: var(--green-700);
  color: var(--green-950);
  background: var(--green-50);
}
.choice-grid .check {
  position: absolute;
  right: 0.7rem;
  top: 0.7rem;
  color: var(--green-700);
}
.day-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(42px, 1fr));
  gap: 0.35rem;
}
.day-grid button {
  aspect-ratio: 1/1.1;
  padding: 0.2rem;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: white;
  font-size: 0.67rem;
  font-weight: 700;
}
.day-grid small {
  display: none;
}
.slot-list {
  display: grid;
  gap: 0.5rem;
}
.slot-list button {
  padding: 0.85rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: white;
  font-size: 0.83rem;
  font-weight: 700;
}
.form-control,
.form-select,
.input-group-text {
  border-color: var(--line);
  border-radius: 12px;
  min-height: 48px;
}
.form-control:focus,
.form-select:focus {
  border-color: var(--green-700);
  box-shadow: 0 0 0 0.2rem rgba(37, 106, 75, 0.12);
}
.schedule-summary {
  height: fit-content;
  padding: 1.2rem;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.schedule-summary > img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  float: left;
  margin-right: 1rem;
  border-radius: 14px;
}
.schedule-summary h3 {
  font-family: var(--font-serif);
  font-size: 1.25rem;
  margin: 0.3rem 0;
}
.schedule-summary > div:nth-child(3) {
  clear: both;
}
.quantity-control {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1.2rem 0;
  padding-top: 1rem;
  border-top: 1px solid var(--line);
  font-weight: 700;
}
.quantity-control div {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}
.quantity-control button {
  width: 34px;
  height: 34px;
  border: 1px solid var(--line);
  border-radius: 50%;
  background: white;
}
.schedule-summary .service-note {
  margin: 1rem 0;
  font-size: 0.8rem;
}
.address-card {
  padding: 1.2rem;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: var(--paper);
  cursor: pointer;
}
.address-card.selected {
  border-color: var(--green-700);
  box-shadow: 0 0 0 2px rgba(37, 106, 75, 0.1);
}
.address-type,
.default-tag {
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.address-type {
  color: var(--green-700);
}
.address-type i {
  margin-right: 0.35rem;
}
.default-tag {
  padding: 0.25rem 0.5rem;
  border-radius: 50px;
  color: var(--green-700);
  background: var(--green-50);
}
.address-card h3 {
  margin: 0.8rem 0 0.25rem;
  font-family: var(--font-sans);
  font-size: 0.95rem;
  font-weight: 800;
}
.address-card p {
  color: var(--muted);
  font-size: 0.85rem;
}
.form-card {
  padding: 1.3rem;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.review-card {
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.review-product {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem;
  background: var(--green-50);
}
.review-product img {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 12px;
}
.review-product div {
  flex: 1;
}
.review-product h2 {
  margin: 0.2rem 0;
  font-family: var(--font-sans);
  font-size: 1rem;
  letter-spacing: 0;
  font-weight: 800;
}
.review-product p {
  margin: 0;
  color: var(--muted);
  font-size: 0.78rem;
}
.review-row {
  display: grid;
  grid-template-columns: 32px 1fr auto;
  gap: 0.6rem;
  padding: 1rem;
  border-top: 1px solid var(--line);
}
.review-row > i {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  color: var(--green-700);
  border-radius: 9px;
  background: var(--green-50);
}
.review-row span,
.review-row strong {
  display: block;
  font-size: 0.8rem;
}
.review-row span {
  color: var(--muted);
}
.review-row p {
  margin: 0.2rem 0 0;
  color: var(--muted);
  font-size: 0.76rem;
}
.review-row a {
  color: var(--green-700);
  font-size: 0.75rem;
  font-weight: 700;
}
.price-summary {
  padding: 1rem;
  border-top: 1px solid var(--line);
}
.price-summary div {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.6rem;
  font-size: 0.85rem;
}
.price-summary small {
  display: block;
  padding-top: 0.8rem;
  border-top: 1px dashed var(--line);
  color: var(--muted);
}
.success-page {
  min-height: 100svh;
  display: grid;
  place-items: center;
  padding: 1rem;
  background: var(--green-50);
}
.success-card {
  width: 100%;
  max-width: 540px;
  padding: 2rem 1.25rem;
  text-align: center;
  border-radius: 24px;
  background: var(--paper);
  box-shadow: var(--shadow);
}
.success-icon {
  width: 80px;
  height: 80px;
  display: grid;
  place-items: center;
  margin: 0 auto 1.2rem;
  border-radius: 50%;
  color: white;
  background: var(--green-700);
  font-size: 2rem;
  box-shadow: 0 0 0 12px var(--green-100);
}
.success-card h1 {
  font-size: 2.6rem;
  margin: 0.4rem 0;
}
.success-card > p {
  color: var(--muted);
}
.success-details {
  margin: 1.5rem 0;
  text-align: left;
}
.success-details > div {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--line);
}
.success-details > div > i {
  width: 32px;
  color: var(--green-700);
  text-align: center;
}
.success-details small,
.success-details strong {
  display: block;
}
.success-details small {
  color: var(--muted);
  font-size: 0.7rem;
}
.success-details strong {
  font-size: 0.85rem;
}

@media (min-width: 576px) {
  .build-basket {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 768px) {
  .choice-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 992px) {
  .schedule-layout {
    grid-template-columns: minmax(0, 1fr) 330px;
    align-items: start;
  }
  .schedule-summary {
    position: sticky;
    top: 1.5rem;
  }
}

.schedule-edit-notice {
  display: flex;
  gap: 0.8rem;
  align-items: flex-start;
  padding: 1rem;
  border: 1px solid #cfe1d4;
  border-radius: 14px;
  background: var(--green-50);
  color: var(--green-950);
  margin-bottom: 1rem;
}
.schedule-edit-notice > i {
  margin-top: 0.15rem;
  color: var(--green-700);
}
.schedule-edit-notice strong,
.schedule-edit-notice span {
  display: block;
}
.schedule-edit-notice span {
  margin-top: 0.2rem;
  color: var(--muted);
  font-size: 0.8rem;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/css/Schedule.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC,SAAS;AACT;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;;;EAGE,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mDAAmD;EACnD,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,8BAA8B;EAC9B,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;;EAEE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,2CAA2C;IAC3C,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* Page-specific styles for Schedule */\n\n/* Flow */\n.flow-header {\n  height: 68px;\n  padding: 0 1rem;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  border-bottom: 1px solid var(--line);\n  background: var(--paper);\n}\n.flow-header .step-label {\n  justify-self: end;\n  color: var(--muted);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n.flow-container {\n  max-width: 1060px;\n  padding-top: 1.5rem;\n  padding-bottom: 4rem;\n}\n.flow-progress {\n  display: flex;\n  gap: 0.4rem;\n  margin-bottom: 2rem;\n}\n.flow-progress span {\n  height: 4px;\n  flex: 1;\n  border-radius: 5px;\n  background: var(--line);\n}\n.flow-progress span.active {\n  background: var(--green-700);\n}\n.schedule-layout {\n  display: grid;\n  gap: 1.5rem;\n}\n.form-section {\n  margin-bottom: 1rem;\n  padding: 1.25rem;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.form-section-title {\n  display: flex;\n  gap: 0.8rem;\n  margin-bottom: 1rem;\n}\n.form-section-title > span {\n  width: 30px;\n  height: 30px;\n  display: grid;\n  place-items: center;\n  border-radius: 9px;\n  color: white;\n  background: var(--green-800);\n  font-size: 0.75rem;\n  font-weight: 800;\n}\n.form-section-title h2 {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 1rem;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n.form-section-title p {\n  margin: 0.1rem 0 0;\n  color: var(--muted);\n  font-size: 0.78rem;\n}\n\n.scheduled-days-note p {\n  color: rgb(24, 153, 125) !important;\n}\n\n.choice-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.6rem;\n}\n.choice-grid button {\n  min-height: 94px;\n  padding: 0.8rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.45rem;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  background: white;\n  position: relative;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n.choice-grid button > i:first-child {\n  color: var(--green-700);\n  font-size: 1.1rem;\n}\n.choice-grid button.selected,\n.slot-list button.selected,\n.day-grid button.selected {\n  border-color: var(--green-700);\n  color: var(--green-950);\n  background: var(--green-50);\n}\n.choice-grid .check {\n  position: absolute;\n  right: 0.7rem;\n  top: 0.7rem;\n  color: var(--green-700);\n}\n.day-grid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(42px, 1fr));\n  gap: 0.35rem;\n}\n.day-grid button {\n  aspect-ratio: 1/1.1;\n  padding: 0.2rem;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  background: white;\n  font-size: 0.67rem;\n  font-weight: 700;\n}\n.day-grid small {\n  display: none;\n}\n.slot-list {\n  display: grid;\n  gap: 0.5rem;\n}\n.slot-list button {\n  padding: 0.85rem 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  background: white;\n  font-size: 0.83rem;\n  font-weight: 700;\n}\n.form-control,\n.form-select,\n.input-group-text {\n  border-color: var(--line);\n  border-radius: 12px;\n  min-height: 48px;\n}\n.form-control:focus,\n.form-select:focus {\n  border-color: var(--green-700);\n  box-shadow: 0 0 0 0.2rem rgba(37, 106, 75, 0.12);\n}\n.schedule-summary {\n  height: fit-content;\n  padding: 1.2rem;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.schedule-summary > img {\n  width: 80px;\n  height: 80px;\n  object-fit: cover;\n  float: left;\n  margin-right: 1rem;\n  border-radius: 14px;\n}\n.schedule-summary h3 {\n  font-family: var(--font-serif);\n  font-size: 1.25rem;\n  margin: 0.3rem 0;\n}\n.schedule-summary > div:nth-child(3) {\n  clear: both;\n}\n.quantity-control {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1.2rem 0;\n  padding-top: 1rem;\n  border-top: 1px solid var(--line);\n  font-weight: 700;\n}\n.quantity-control div {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n}\n.quantity-control button {\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--line);\n  border-radius: 50%;\n  background: white;\n}\n.schedule-summary .service-note {\n  margin: 1rem 0;\n  font-size: 0.8rem;\n}\n.address-card {\n  padding: 1.2rem;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  background: var(--paper);\n  cursor: pointer;\n}\n.address-card.selected {\n  border-color: var(--green-700);\n  box-shadow: 0 0 0 2px rgba(37, 106, 75, 0.1);\n}\n.address-type,\n.default-tag {\n  font-size: 0.7rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n.address-type {\n  color: var(--green-700);\n}\n.address-type i {\n  margin-right: 0.35rem;\n}\n.default-tag {\n  padding: 0.25rem 0.5rem;\n  border-radius: 50px;\n  color: var(--green-700);\n  background: var(--green-50);\n}\n.address-card h3 {\n  margin: 0.8rem 0 0.25rem;\n  font-family: var(--font-sans);\n  font-size: 0.95rem;\n  font-weight: 800;\n}\n.address-card p {\n  color: var(--muted);\n  font-size: 0.85rem;\n}\n.form-card {\n  padding: 1.3rem;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.review-card {\n  overflow: hidden;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.review-product {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  padding: 1rem;\n  background: var(--green-50);\n}\n.review-product img {\n  width: 64px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: 12px;\n}\n.review-product div {\n  flex: 1;\n}\n.review-product h2 {\n  margin: 0.2rem 0;\n  font-family: var(--font-sans);\n  font-size: 1rem;\n  letter-spacing: 0;\n  font-weight: 800;\n}\n.review-product p {\n  margin: 0;\n  color: var(--muted);\n  font-size: 0.78rem;\n}\n.review-row {\n  display: grid;\n  grid-template-columns: 32px 1fr auto;\n  gap: 0.6rem;\n  padding: 1rem;\n  border-top: 1px solid var(--line);\n}\n.review-row > i {\n  width: 30px;\n  height: 30px;\n  display: grid;\n  place-items: center;\n  color: var(--green-700);\n  border-radius: 9px;\n  background: var(--green-50);\n}\n.review-row span,\n.review-row strong {\n  display: block;\n  font-size: 0.8rem;\n}\n.review-row span {\n  color: var(--muted);\n}\n.review-row p {\n  margin: 0.2rem 0 0;\n  color: var(--muted);\n  font-size: 0.76rem;\n}\n.review-row a {\n  color: var(--green-700);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n.price-summary {\n  padding: 1rem;\n  border-top: 1px solid var(--line);\n}\n.price-summary div {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.6rem;\n  font-size: 0.85rem;\n}\n.price-summary small {\n  display: block;\n  padding-top: 0.8rem;\n  border-top: 1px dashed var(--line);\n  color: var(--muted);\n}\n.success-page {\n  min-height: 100svh;\n  display: grid;\n  place-items: center;\n  padding: 1rem;\n  background: var(--green-50);\n}\n.success-card {\n  width: 100%;\n  max-width: 540px;\n  padding: 2rem 1.25rem;\n  text-align: center;\n  border-radius: 24px;\n  background: var(--paper);\n  box-shadow: var(--shadow);\n}\n.success-icon {\n  width: 80px;\n  height: 80px;\n  display: grid;\n  place-items: center;\n  margin: 0 auto 1.2rem;\n  border-radius: 50%;\n  color: white;\n  background: var(--green-700);\n  font-size: 2rem;\n  box-shadow: 0 0 0 12px var(--green-100);\n}\n.success-card h1 {\n  font-size: 2.6rem;\n  margin: 0.4rem 0;\n}\n.success-card > p {\n  color: var(--muted);\n}\n.success-details {\n  margin: 1.5rem 0;\n  text-align: left;\n}\n.success-details > div {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid var(--line);\n}\n.success-details > div > i {\n  width: 32px;\n  color: var(--green-700);\n  text-align: center;\n}\n.success-details small,\n.success-details strong {\n  display: block;\n}\n.success-details small {\n  color: var(--muted);\n  font-size: 0.7rem;\n}\n.success-details strong {\n  font-size: 0.85rem;\n}\n\n@media (min-width: 576px) {\n  .build-basket {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 768px) {\n  .choice-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (min-width: 992px) {\n  .schedule-layout {\n    grid-template-columns: minmax(0, 1fr) 330px;\n    align-items: start;\n  }\n  .schedule-summary {\n    position: sticky;\n    top: 1.5rem;\n  }\n}\n\n.schedule-edit-notice {\n  display: flex;\n  gap: 0.8rem;\n  align-items: flex-start;\n  padding: 1rem;\n  border: 1px solid #cfe1d4;\n  border-radius: 14px;\n  background: var(--green-50);\n  color: var(--green-950);\n  margin-bottom: 1rem;\n}\n.schedule-edit-notice > i {\n  margin-top: 0.15rem;\n  color: var(--green-700);\n}\n.schedule-edit-notice strong,\n.schedule-edit-notice span {\n  display: block;\n}\n.schedule-edit-notice span {\n  margin-top: 0.2rem;\n  color: var(--muted);\n  font-size: 0.8rem;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
